// extracted by mini-css-extract-plugin
export default {"info":"MetadataInfo_info__n6mzP","input":"MetadataInfo_input__kCnPb","item":"MetadataInfo_item__DPbWL","name":"MetadataInfo_name__qCnkL"};